import createEngineRoot from './createEngineRoot'
import { getDefaultStateMapDisk } from '../state/getDefaultStateMapDisk'

// placeholder for declaring intent
const createEngineForUI = function () {
  return createEngineRoot(getDefaultStateMapDisk())
}

export default createEngineForUI
